import api from '~/modules/services/api-service';

const GET_GROUPS_AND_USERS_QUERY = `
query getGroupsAndUsers($groups: [ID], $users: [ID], $skipGroups: Boolean!, $skipUsers: Boolean!) {
  groups(id: $groups) @skip(if: $skipGroups) {
    nodes {
      id
      name
    }
  },
	users(id: $users) @skip(if: $skipUsers){
		nodes {
			id
			name
			emailNormal
		}
  }
}
`;

export const ContactListsService = {
	getGroupsAndUsers(groups, users) {
		let skipGroups = false;
		let skipUsers = false;

		if( !groups?.length ) {
			skipGroups=true;
		}
		if( !users?.length ) {
			skipUsers = true;
		}
		return api.graphql.request(GET_GROUPS_AND_USERS_QUERY, { groups, users, skipGroups, skipUsers });
	}
};

